@if (isAuthenticateUser()) {
  <div class="okc-page">
    @if (!isMobile()) {
      <div class="okc-sidebar">
        <app-sidebar></app-sidebar>
      </div>
    }

    <mat-drawer-container class="okc-main-container">
      <!-- Sidenav (Columna lateral + acciones en móviles) -->
      <mat-drawer
        class="sidenav"
        #sidenav
        mode="over"
      >
        @if (isMobile()) {
          <app-sidenav-mobile></app-sidenav-mobile>
        }
      </mat-drawer>

      <mat-drawer-content>
        <mat-toolbar
          class="okc-top-toolbar"
          color="primary"
        >
          <!-- TODO show/hide mobile menu -->
          @if (isMobile()) {
            <button
              matIconButton
              (click)="sidenav.toggle()"
            >
              <mat-icon>menu</mat-icon>
            </button>
          }

          <app-top-toolbar></app-top-toolbar>
        </mat-toolbar>

        <div class="okc-content">
          <router-outlet></router-outlet>
        </div>
      </mat-drawer-content>
    </mat-drawer-container>
  </div>
} @else {
  <router-outlet></router-outlet>
}
